// src/render/assetManifest.js

export const SPRITES = {
  background: {
    path: 'assets/background.png',
    width: 800,
    height: 600
  },
  penguin: {
    path: 'assets/penguin.png',
    width: 20,
    height: 20
  },
  crocodile: {
    path: 'assets/crocodile.png',
    width: 20,
    height: 20
  },
  goat: {
    path: 'assets/goat.png',
    width: 20,
    height: 20
  },
  fastEnemy: {
    path: 'assets/fastEnemy.png',
    width: 20,
    height: 20
  },
  tankEnemy: {
    path: 'assets/tankEnemy.png',
    width: 30,
    height: 30
  },
  shooterEnemy: {
    path: 'assets/shooterEnemy.png',
    width: 20,
    height: 20
  },
  human: {
    path: 'assets/human.png',
    width: 15,
    height: 15
  },
  heroBullet: {
    path: 'assets/heroBullet.png',
    width: 10,
    height: 3
  },
  powerBullet: {
    path: 'assets/powerBullet.png',
    width: 15,
    height: 5
  },
  shieldBullet: {
    path: 'assets/shieldBullet.png',
    width: 10,
    height: 3
  },
  enemyBullet: {
    path: 'assets/enemyBullet.png',
    width: 10,
    height: 10
  },
  massiveExplosionParticle: {
    path: 'assets/massiveExplosionParticle.png',
    width: 15,
    height: 15
  },
  explosionParticle: {
    path: 'assets/explosionParticle.png',
    width: 10,
    height: 10
  },
  ultimateParticle: {
    path: 'assets/ultimateParticle.png',
    width: 10,
    height: 10
  },
};
